export enum ContentControlledLinkedFileMediaTypeEnum {
  Audio = 1,
  Subtitle,
}
